export function capitalize(text) {
    if (!text)
        return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
}
/**
 * Extracts the first letter from one or all words in the specified text.
 *
 * @param text text to extract the intials from
 * @param wordIndex optional. If defined, the initial is extracted from the word with that index.
 * Otherwise the first letter from each word in the text is returned.
 */
export function getInitials(text, wordStart, length) {
    if (length === 0)
        return "";
    const all = getAllInitials(text, wordStart);
    if (length === undefined)
        return all;
    return all.substring(0, length);
}
function getAllInitials(text, wordStart = 0) {
    if (!text)
        return "";
    if (wordStart === 0)
        return text.charAt(0);
    const words = text.split(" ").map(w => w.charAt(0)).join("");
    if (wordStart > (words.length - 1)) {
        throw new Error(`Word index out of bounds. Text contains only ${words.length} words. Index ${wordStart} does not exist`);
    }
    return words.substr(wordStart);
    // return words[wordStart].charAt(0);
}
/**
 * Agrega la cantidad de caracteres necesarios a la izquierda
 * de un string o numero para que tenga la longitud deseada.
 *
 * Se debe especificar la longitud deseada y el caracter a usar.
 *
 * @param {(string|number)} value string a completar
 * @param {number} size tamanio final que debe tener
 * @param {string} char caracter a usar para rellenar
 * @returns
 */
export function padLeft(value, size, char) {
    return Array(size - String(value).length + 1).join(char) + value;
}
/**
* Aplica padLeft usando ceros
*
* @param {(string|number)} value
* @param {number} size
* @returns
*/
export function padZero(value, size) {
    return padLeft(value, size, '0');
}
export function joinURL(segments) {
    return segments.reduce((base, segment) => {
        if (!base)
            return segment;
        if (base.endsWith('/') || segment.startsWith('/'))
            return base + segment;
        return `${base}/${segment}`;
    }, undefined);
}
//# sourceMappingURL=string.js.map